const FavHeartIcon = ({
  width = 50,
  height = 44,
  fill = "#ED5F4B",
  stroke = "#ED5F4B",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 44"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.2 20.9562L25.4331 41.8563L25.4239 41.8468L25.4148 41.8563L5.64791 20.9562C1.63299 16.6887 1.63299 9.85153 5.64791 5.58409C9.64984 1.52453 16.0203 1.52453 20.0222 5.58409L25.4012 11.3213L25.4239 11.2975L25.4467 11.3213L30.8211 5.58409C34.8237 1.52145 41.1975 1.52145 45.2 5.58409C49.2149 9.85153 49.2149 16.6887 45.2 20.9562V20.9562Z"
      stroke={stroke}
      strokeWidth="2.9508"
    />
  </svg>
);

export default FavHeartIcon;
